import { GraphQLEnumType } from 'graphql';

module.exports = new GraphQLEnumType({
  name: 'BlockVariantEnum',
  values: {
    paragraph: {
      value: 'paragraph'
    },
    headingParagraph: {
      value: 'headingParagraph'
    },
    subheadingParagraph: {
      value: 'subheadingParagraph'
    },
    heading: {
      value: 'heading'
    },
    subheading: {
      value: 'subheading'
    },
    twoColumn: {
      value: 'twoColumn'
    },
    hero: {
      value: 'hero'
    },
    full: {
      value: 'full'
    },
    textAside: {
      value: 'textAside'
    },
    textOverlay: {
      value: 'textOverlay'
    },
    audio: {
      value: 'audio'
    },
    video: {
      value: 'video'
    },
    embed: {
      value: 'embed'
    },
    attachment: {
      value: 'attachment'
    },
    singleSelect: {
      value: 'singleSelect'
    },
    multiSelect: {
      value: 'multiSelect'
    },
    fourColumn: {
      value: 'fourColumn'
    },
    centered: {
      value: 'centered'
    },
    threeColumn: {
      value: 'threeColumn'
    },
    numbered: {
      value: 'numbered'
    },
    checkboxes: {
      value: 'checkboxes'
    },
    bulleted: {
      value: 'bulleted'
    },
    textAsideLeft: {
      value: 'textAsideLeft'
    },
    textAsideRight: {
      value: 'textAsideRight'
    },
    a: {
      value: 'a'
    },
    b: {
      value: 'b'
    },
    c: {
      value: 'c'
    },
    quoteD: {
      value: 'quoteD'
    },
    fullBackground: {
      value: 'fullBackground'
    },
    fullCImpact: {
      value: 'fullCImpact'
    },
    fullDImpact: {
      value: 'fullDImpact'
    },
    html: {
      value: 'html'
    },
    flashcardStack: {
      value: 'flashcardStack'
    },
    flashcardGrid: {
      value: 'flashcardGrid'
    },
    tabs: {
      value: 'tabs'
    },
    accordion: {
      value: 'accordion'
    }
  }
});
